module.exports = __webpack_public_path__ + "img/balkonbruestung.9c871f9e.jpg";